import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import BaseListagem from "components/BaseListagem";
import ReportEdit from "components/reports/ReportEdit";
import Setor from "model/administracao/cadastro/Setor";
import ItemClasseAuditoria from "model/auditoria5s/auditoria/ItemClasseAuditoria";
import { FilterMatchMode, FilterOperator } from "primereact/api";
import { Button } from "primereact/button";
import { Column, ColumnFilterElementTemplateOptions } from "primereact/column";
import { DataTableFilterMeta } from "primereact/datatable";
import { Dialog } from "primereact/dialog";
import { Dropdown } from "primereact/dropdown";
import { SplitButton } from "primereact/splitbutton";
import { useLoadingContext } from "provider/LoadingProvider";
import { useEffect, useState } from "react";
import { useNavigate } from 'react-router';
import ItemAuditoriaService from "service/auditoria5s/ItemAuditoriaService";
import UsuarioLogadoService from "service/usuario/UsuarioLogadoService";
import { converterDataHora } from "utils/convert";
import saveAs from 'file-saver';
import { DateMatchModeOptions, dateRangeFilterTemplate, filterApplyTemplate, IdMatchModeOptions, ListMatchModeOptions, NumberMatchModeOptions, statusFilterTemplate, TextMatchModeOptions } from "utils/filterUtils";
import { useToastContext } from "components/alert/ToastContext";

const itemAuditoriaService = new ItemAuditoriaService();
const usuarioLogadoService = new UsuarioLogadoService();

export default function ItemAuditoriaListagem() {

    const [setoresDisponiveis, setSetoresDisponiveis] = useState<Setor[]>([]);
    const [visibleDialogRelatorio, setVisibleDialogRelatorio] = useState(false);
    const [editaRelatorio, setEditaRelatorio] = useState(false);
    const { msgSucesso, msgErro, msgAlerta } = useToastContext();
    const { startLoading, stopLoading } = useLoadingContext();

    const navigate = useNavigate();

    const defaultFilters: DataTableFilterMeta = {
        numeroAuditoria: {
            constraints: [
                {
                    value: "",
                    matchMode: FilterMatchMode.EQUALS,
                }
            ],
            operator: FilterOperator.AND
        },
        setor: {
            constraints: [
                {
                    value: '',
                    matchMode: FilterMatchMode.EQUALS,
                }
            ],
            operator: FilterOperator.AND
        },
        nomeAuditoria: {
            constraints: [
                {
                    value: '',
                    matchMode: FilterMatchMode.STARTS_WITH,
                }
            ],
            operator: FilterOperator.AND
        },
        nomeItem: {
            constraints: [
                {
                    value: '',
                    matchMode: FilterMatchMode.STARTS_WITH,
                }
            ],
            operator: FilterOperator.AND
        },
        dataGeracaoAuditoria: {
            constraints: [
                {
                    value: null,
                    matchMode: FilterMatchMode.EQUALS,
                }
            ],
            operator: FilterOperator.AND
        },
        resultado: {
            constraints: [
                {
                    value: [],
                    matchMode: FilterMatchMode.IN,
                }
            ],
            operator: FilterOperator.AND
        },
        resposta: {
            constraints: [
                {
                    value: '',
                    matchMode: FilterMatchMode.STARTS_WITH,
                }
            ],
            operator: FilterOperator.AND
        },
    }
    const [filters, setFilters] = useState<DataTableFilterMeta>(defaultFilters);


    const setorFilterTemplate = (options: ColumnFilterElementTemplateOptions) => {
        return <Dropdown value={options.value} options={setoresDisponiveis} filter
            onChange={(e) => options.filterCallback(e.value)}
            optionLabel="nome" optionValue="id" placeholder="Qualquer" className="p-column-filter" />
    }

    useEffect(() => {
        usuarioLogadoService.getAcoesUsuarioLogado().then((resposta) => {
            if (usuarioLogadoService.usuarioTemAlgumaAcao(resposta, ["RELATORIO_ITEM_AUDITORIA_XLS_EDITAR"])) {
                setEditaRelatorio(true);
            }
        }).catch((erro) => {
            console.log(erro);
        });

        itemAuditoriaService.getSetoresDisponiveis().then(response => setSetoresDisponiveis(response)).catch(() => setSetoresDisponiveis([]));
    }, []);

    const navigateToAuditoria = (item: ItemClasseAuditoria) => {
        let url = `/auditoria/editar/${item.classeAuditoria.auditoria.id}`;
        navigate(`${url}`);
    }

    function getButtonsExtra() {
        return [
            editaRelatorio ? <SplitButton
                icon="pi pi-file-excel"
                onClick={() => gerarRelatorioListagem()}
                model={[{
                    label: "Alterar relatórios",
                    command: () => setVisibleDialogRelatorio(true)
                }]}
            /> : <Button
                type="button"
                icon="pi pi-file-excel"
                onClick={() => gerarRelatorioListagem()}
            />,
        ]
    }

    function gerarRelatorioListagem() {
        startLoading();
        itemAuditoriaService.getRelatorioListagem(filters).then(data => {
            stopLoading();
            const file = new Blob([data], { type: 'application/xls' });
            saveAs(file, `ItensAuditorias.xls`);
        }).catch(err => {
            stopLoading();
            msgErro("Erro ao gerar Relatório", err?.message||"");
            console.log(err);
        });
    }

    return (
        <>
            <Dialog visible={visibleDialogRelatorio}
                onHide={() => setVisibleDialogRelatorio(false)}
                header="Relatórios"
                style={{ width: "50%" }}
            >
                <ReportEdit nomeAcao="RELATORIO_ITEM_AUDITORIA_XLS_EDITAR" titulo="Relatório de listagem" testarRelatorio={() => { }} style={{ marginBottom: 10 }} />
            </Dialog>
            <BaseListagem ordenacao="classeAuditoria.auditoria.dataGeracao,DESC" service={itemAuditoriaService} urlService="/itemAuditoria" tituloPagina={'Itens de Auditoria'}
                showNewButton={false}
                showRemoveButton={false}
                showEditButton={false}
                defaultFilters={defaultFilters} showClearFilterButton
                onChangeFilters={(filters) => setFilters(filters)}
                buttonsExtra={getButtonsExtra()}
                nome="itemAuditoria"
            >
                <Column
                    field="classeAuditoria.auditoria.numero" header="Nr." filterField="numeroAuditoria"
                    filter showFilterOperator={false} showAddButton={false} filterPlaceholder="Escreva o filtro"
                    filterMatchModeOptions={NumberMatchModeOptions} filterApply={filterApplyTemplate}
                />
                <Column
                    field="classeAuditoria.auditoria.setor.nome" header="Setor" filterField="setor"
                    filter showFilterOperator={false} showAddButton={false} filterPlaceholder="Escreva o filtro"
                    filterMatchModeOptions={IdMatchModeOptions} filterApply={filterApplyTemplate} filterElement={setorFilterTemplate}
                />
                <Column
                    field="classeAuditoria.auditoria.nome" header="Nome auditoria"
                    filter showFilterOperator={false} showAddButton={false} filterPlaceholder="Escreva o filtro" filterField="nomeAuditoria"
                    filterMatchModeOptions={TextMatchModeOptions} filterApply={filterApplyTemplate}
                />
                <Column
                    field="nome" header="Requisito"
                    filter showFilterOperator={false} showAddButton={false} filterPlaceholder="Escreva o filtro" filterField="nomeItem"
                    filterMatchModeOptions={TextMatchModeOptions} filterApply={filterApplyTemplate}
                />
                <Column field="classeAuditoria.auditoria.dataGeracao" header="Dt. Geração"
                    body={(rowData) => converterDataHora(rowData.classeAuditoria.auditoria.dataGeracao)}
                    filter showFilterOperator={false} showAddButton={false} filterPlaceholder="Escreva o filtro" filterField="dataGeracaoAuditoria"
                    filterMatchModeOptions={DateMatchModeOptions} filterApply={filterApplyTemplate}
                    filterElement={dateRangeFilterTemplate} filterMenuStyle={{ zIndex: 50 }} />
                <Column field="resultado" header="Resultado"
                    filter showFilterOperator={false} showAddButton={false} filterPlaceholder="Escreva o filtro"
                    filterMatchModeOptions={ListMatchModeOptions} filterApply={filterApplyTemplate} filterElement={(options) => statusFilterTemplate(options, itemAuditoriaService.getResultadoFilter())}
                    body={(rowData) => {
                        return itemAuditoriaService.getResultado(rowData.resultado)
                    }}
                />
                <Column
                    field="resposta" header="Resposta" body={(rowData) => rowData.respostaEscolhida ? rowData.respostaEscolhida : rowData.resposta}
                    filter showFilterOperator={false} showAddButton={false} filterPlaceholder="Escreva o filtro"
                    filterMatchModeOptions={TextMatchModeOptions} filterApply={filterApplyTemplate}
                />
                <Column key="colOpcoes" style={{ whiteSpace: 'nowrap', width: '3em' }}
                    body={(item) => <Button type="button" icon={<FontAwesomeIcon icon="edit" />} className="ui-button-info" onClick={() => navigateToAuditoria(item)}></Button>}
                />
            </BaseListagem>
        </>

    )
}
